
export default () => ({
  show: false,
  loading: false,
  isLoading: false,
  onCancel: false,
  fullPage: true,
  meeting: [],
  meetings: []
})



// WEBPACK FOOTER //
// ./src/app/dweller/meeting/details/resources/data.js